import { Box, Divider, Tab, Tabs } from '@mui/material';
import { useEffect } from 'react';
import { Typography } from 'src/components/new/Typography';
import { Button } from 'src/components/new/Button';
import Customers from './Customers';
import PromoCodes from './PromoCodes';
import { AppDispatch } from 'src/store/store';
import { useDispatch } from 'react-redux';
import { setIsAddPromoCodeModalOpen, updatePromoCodeForm } from 'src/features/admin/adminSlice';
import PostageRates from './PostageRates';
import WeightCriticalInput from './WeightCriticalInput';
import DocumentProcessingRates from './DocumentProcessingRates';
import { useSearchParams } from 'react-router-dom';

const availableTabs = [
  { label: 'Customers', component: <Customers />, queryParam: 'customers' },
  {
    label: 'USPS Postage Rates',
    component: <PostageRates />,
    queryParam: 'postage',
  },
  {
    label: 'Document Processing',
    component: <DocumentProcessingRates />,
    queryParam: 'pricing',
  },
  {
    label: 'Weight',
    component: <WeightCriticalInput />,
    queryParam: 'weight',
  },
  { label: 'Promo Codes', component: <PromoCodes />, queryParam: 'codes' },
];

const Pricing: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab');
  const activeTabIndex = Math.max(
    0,
    availableTabs.findIndex((tab) => tab.queryParam === activeTab),
  );

  useEffect(() => {
    const isValid = availableTabs.some(
    (tab) => tab.queryParam === activeTab
  );

  if (!activeTab || !isValid) {
    setSearchParams(
      { tab: availableTabs[0].queryParam },
      { replace: true }
    );
  }
  }, [activeTab, availableTabs, setSearchParams]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSearchParams({ tab: availableTabs[newValue].queryParam });
  };

  const onAddPromoCodeClick = () => {
    dispatch(setIsAddPromoCodeModalOpen(true));
    dispatch(updatePromoCodeForm({ name: '', startAt: '', endAt: '', printCreditEndAt: '', printCreditAmount: '' }));
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '1.5rem' }}>
        <Typography
          sx={{ fontFamily: 'ABC Arizona Mix', fontWeight: 300, fontSize: '2.8125rem', lineHeight: '3.25rem' }}
        >
          {activeTabIndex === 4 ? 'Promo Codes' : 'Pricing'}
        </Typography>
        <Button
          onClick={onAddPromoCodeClick}
          sx={{ width: '12.5rem', ...(activeTabIndex !== 4 && { display: 'none' }) }}
          type="primary"
        >
          + Add Promo Code
        </Button>
      </Box>
      <Box>
        <Box sx={{ paddingLeft: '1.5rem' }}>
          <Tabs
            TabIndicatorProps={{
              sx: { backgroundColor: '#436eb2' },
            }}
            value={activeTabIndex}
            onChange={handleTabChange}
          >
            {availableTabs.map((tab) => (
              <Tab
                key={`tab_${tab.label}`}
                label={tab.label}
                sx={{
                  textTransform: 'none',
                  fontFamily: 'Instrument Sans',
                  fontSize: '1rem',
                  lineHeight: '1.25rem',
                  textAlign: 'center',
                  color: '#45464F',
                  '&.Mui-selected': {
                    color: '#436eb2',
                  },
                }}
              />
            ))}
          </Tabs>
        </Box>
        <Divider />
        <Box sx={{ padding: '1.5rem' }}>
          {availableTabs[activeTabIndex]?.component || <Typography>No content available</Typography>}
        </Box>
      </Box>
    </Box>
  );
};

export default Pricing;
